<template>
  <div class="py-6 px-3 py-md-12 px-md-6 px-lg-12">
    <v-sheet class="mx-auto pa-6" max-width="1230">
      <Loader :messageSelector="messageSelector" :overlay="overlay" />

      <TextesDemission />

      <v-form ref="form" v-model="valid">
        <ChampsDemission v-model="champsDemission" />
      </v-form>

      <div class="text-center mt-6">
        <v-btn :disabled="!valid" color="primary" @click="afficherConfirmation()">Je démissionne</v-btn>
      </div>

      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="headline">Attention</v-card-title>
          <v-card-text class="subtitle-1">
            <RessourceInfoBulle code="DE-POPUP" />
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" text @click="dialog = false">Annuler</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="processDemission()">Je confirme ma démission</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Loader from "@/components/Loader"
import TextesDemission from "@/components/Demission/TextesDemission"
import ChampsDemission from "@/components/Demission/ChampsDemission"
import ParamFormulaire from "@/mixins/paramFormulaire"

export default {
  components: {
    Loader,
    TextesDemission,
    ChampsDemission,
  },
  mixins: [ParamFormulaire],
  data() {
    return {
      overlay: false,
      messageSelector: "",
      valid: false,
      dialog: false,
      champsDemission: {
        raisonDuRetrait: null,
        reinscriptionPrevue: null,
        precisionRetrait: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      getAutorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      getAccesFormulaireDemission: "DemandeInscription/GET_ACCES_FORMULAIRE_DEMISSION",
    }),
    listeAutorisationsDePratique() {
      return this.getAutorisations.filter(
        (a) =>
          a.statut?.id === this.$catalogues.statutAutorisationDePatique.membre ||
          a.statut?.id === this.$catalogues.statutAutorisationDePatique.droitsAcquis
      )
    },
  },
  async mounted() {
    await this.loadParams(this.$paramFormulaire.codeFormulaireDemission)
  },
  async created() {
    await this.handleAuthorization()
    await this.handleDemandeInscription()
  },
  methods: {
    ...mapMutations({
      setDemandeInscriptionId: "DemandeInscription/SET_ID",
      setContactId: "DemandeInscription/SET_CONTACTID",
    }),
    ...mapActions({
      getContactAccesFormulaires: "DemandeInscription/getContactAccesFormulaires",
      createDemandeInscription: "DemandeInscription/createDemandeInscription",
      getAutorisationDePratiqueByDemandeInscriptionId: "AutorisationDePratique/getAutorisationDePratiqueByDemandeInscriptionId",
      updateAutorisationDePratique: "AutorisationDePratique/updateAutorisationDePratique",
      demission: "DemandeInscription/demission",
      retraitVolontaire: "DemandeInscription/retraitVolontaire",
      demandeTerminee: "DemandeInscription/demandeTerminee",
    }),
    async handleAuthorization() {
      try {
        if (this.$route.query.contactId == null) {
          this.$router.push({ name: "InternalError", params: { message: "Un contact est obligatoire" } })
          return
        }
        this.setContactId(this.$route.query.contactId)
        await this.getContactAccesFormulaires(this.$route.query.contactId)
        if (!this.getAccesFormulaireDemission) {
          this.$router.push({ name: "InternalError", params: { message: "Vous n'avez pas les droits nécessaires pour accéder à cette page" } })
        }
      } catch {
        this.$router.push({ name: "InternalError", params: { message: "Une erreur est survenue lors de la tentative d'autorisation" } })
      }
    },
    async handleDemandeInscription() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        let inscriptionId = this.$route.query.demandeInscriptionId
        if (inscriptionId == null) {
          let typeInscription = { id: process.env.VUE_APP_TYPEINSCRIPTION_RENOUVELLEMENT }
          inscriptionId = await this.createDemandeInscription({
            contactEncryptedId: this.$route.query.contactId,
            typeInscription: typeInscription,
          })
        }

        this.setDemandeInscriptionId(inscriptionId)

        if (inscriptionId) {
          await this.getAutorisationDePratiqueByDemandeInscriptionId(inscriptionId)
        }

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
        this.overlay = false
      }
    },
    afficherConfirmation() {
      if (this.$refs.form?.validate()) {
        this.dialog = true
      }
    },
    async processDemission() {
      this.dialog = false
      this.messageSelector = "Save"
      this.overlay = true

      // Même traitement que le retrait volontaire du renouvellement : toutes les autorisations passent en retrait volontaire
      for (const element of this.listeAutorisationsDePratique) {
        element.raisonRadiation = {
          id: this.$catalogues.motifRadiationAutorisationDePatique.retraitVolontaire,
        }
        await this.updateAutorisationDePratique(element)
      }

      await this.demission(this.champsDemission)
      await this.retraitVolontaire()
      await this.demandeTerminee()

      await this.$router.push({
        name: `DemandeInscription/RetraitVolontaire`,
      })
    },
  },
}
</script>

<style></style>
